export const SUCCESS_STATUS = 'SUCCESS';
export const BLOCKED_STATUS = 'BLOCKED';
